enum Page {
  checkout = '/',
  notFound = '/not-found',
  auth = '/auth',
}

export default Page;
